import { getResolvedTheme, subscribeToTheme } from '../theme.js'

const darkNeutralColors = {
  background: '#111827',
  surface: '#1f2937',
  'surface-variant': '#273548',
  primary: '#66d9ef',
  secondary: '#334155',
  success: '#66bb6a',
  warning: '#ffb74d',
  error: '#ef5350',
  info: '#66d9ef',
  'on-background': '#e5e7eb',
  'on-surface': '#e5e7eb',
  'on-surface-variant': '#cbd5e1',
  outline: '#52627a'
}

export function createModuleThemes (name, lightColors, darkColors = {}) {
  return {
    [name]: {
      dark: false,
      colors: lightColors
    },
    [`${name}Dark`]: {
      dark: true,
      colors: {
        ...darkNeutralColors,
        primary: lightColors.primary,
        info: lightColors.info || lightColors.primary,
        ...darkColors
      }
    }
  }
}

export function bindVuetifyTheme (vuetify, name) {
  const lightName = name
  const darkName = `${name}Dark`

  function update (theme) {
    vuetify.theme.global.name.value = theme === 'dark' ? darkName : lightName
  }

  update(getResolvedTheme())
  return subscribeToTheme(({ theme }) => update(theme))
}

export function defaultThemeName (name) {
  return getResolvedTheme() === 'dark' ? `${name}Dark` : name
}

